import {
    Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

@Component({
})

export default class Zipcode extends Vue {
    @Prop({ required: true }) zip!: string;

    @Prop({ required: true }) onZipUpdated!: (zipCode: string) => void;

    @Prop({ required: false }) onZipActive!: (value: boolean) => void;

    private newZipCode: string = this.zip? this.zip.slice(0, 5) : '';

    // eslint-disable-next-line camelcase
    active_el = 0;

    onZipClick(e: Event) {
        this.$emit('zipEntered', this.newZipCode);
    }

    onZipEnter(e: KeyboardEventInit): void {
        if (e.key === 'Enter') {
            this.$emit('zipEntered', this.newZipCode);
        }
    }

    get newZipCodeUpdated() {
        return this.zip.slice(0, 5);
    }

    set newZipCodeUpdated(zip) {
        this.newZipCode = zip.slice(0, 5);
        if (zip.length === 5) {
            this.onZipUpdated(this.newZipCode);
            this.onZipActive(true);
        }
        if (this.newZipCode.length !== 5) {
            this.onZipActive(false);
        }
    }
}
